module.exports = __webpack_public_path__ + "img/R2.2028dc49.png";